<template>
  <div class="deliverable-assets-list-view">
    <div class="breadcrumb-header pa-4 d-flex align-center">
      <v-btn icon class="mr-2" @click="$router.back()"><v-icon>mdi-arrow-left</v-icon></v-btn>
      <span class="text-h6">{{ jobData.job_title || 'Novo job' }}</span>
      <v-icon class="mx-2">mdi-chevron-right</v-icon>
      <span class="text-h6 grey--text">{{ $t('deliverables_list') }}</span>
      <v-spacer></v-spacer>

      <v-btn v-if="canEditDeliverables" color="primary" class="mr-2" @click="openMultiFileUploadView">
        <v-icon left>mdi-upload-multiple</v-icon>
        {{ $t('multi_file_upload') }}
      </v-btn>

      <v-menu v-if="canEditDeliverables" offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn outlined color="primary" class="mr-2" v-bind="attrs" v-on="on">
            <span>PRESETS</span>
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="openDeliverableManagement('preset')">
            <v-list-item-icon class="mr-2">
              <v-icon>mdi-download</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('load_preset') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn v-if="canEditDeliverables" color="primary" @click="openDeliverableManagement('add')">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('add_deliverable') }}
      </v-btn>
    </div>

    <DeliverableAssetsListManagement :job-id="effectiveJobId" :job-data="jobData" :customer-id="customerId || jobData.customer_id" @acl-loaded="jobAcl = $event" />
  </div>
</template>

<script>
import DeliverableAssetsListManagement from '@/components/job/DeliverableAssetsListManagement.vue'
import JobAPI from '@/services/api/job/job'

export default {
  name: 'JobDeliverableAssetsList',
  components: { DeliverableAssetsListManagement },
  props: { jobId: { type: [String, Number], default: null }, customerId: { type: [String, Number], default: null } },
  data: () => ({ jobData: {}, jobAcl: 0 }),
  mounted() { this.loadJobData() },
  methods: {
    async loadJobData() {
      if (!this.effectiveJobId) return
      try {
        const response = await JobAPI.getJob(this.effectiveJobId)
        this.jobData = response.data || {}
      } catch (error) {
        console.error('Error loading job for deliverable asset list:', error)
      }
    },
    openMultiFileUploadView() {
      this.$router.push({
        name: 'JobMultiFileUpload',
        params: this.deliverableRouteParams
      })
    },
    openDeliverableManagement(action) {
      this.$router.push({
        name: 'JobDeliverableManagement',
        params: this.deliverableRouteParams,
        query: { action }
      })
    }
  },
  computed: {
    effectiveJobId() { return this.jobId || this.$route.params.jobId },
    canEditDeliverables() { return !this.jobData?.readonly && (this.jobAcl & 128) === 128 },
    deliverableRouteParams() {
      return {
        appId: this.$route.params.appId,
        jobId: this.effectiveJobId,
        contentAppId: this.$route.params.contentAppId,
        businessAppId: this.$route.params.businessAppId
      }
    }
  }
}
</script>

<style scoped>
.deliverable-assets-list-view { min-height: 100vh; background-color: #f5f5f5; }

@media (max-width: 960px) {
  .breadcrumb-header { flex-wrap: wrap; gap: 8px; }
  .breadcrumb-header .v-spacer { display: none; }
}

@media (max-width: 600px) {
  .breadcrumb-header { padding: 12px !important; }
  .breadcrumb-header .text-h6 { font-size: 1rem !important; }
  .breadcrumb-header > .v-btn { margin-right: 0 !important; }
}
</style>
